import clone from "lodash/clone";
import flatten from "lodash/flatten";
import get from "lodash/get";
import isArray from "lodash/isArray";
import isBoolean from "lodash/isBoolean";
import isNil from "lodash/isNil";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import toPairs from "lodash/toPairs";

const replacementSymbol = Symbol("replacement");

export function mergeImmigramFormConfig(
  immigramFormsConfigSegments: any[],
  inputData: Record<string, string | null>
): any[] {
  const mergedConfig = immigramFormsConfigSegments.reduce(
    (acc, configSegment) => {
      if (
        isConfigSectionEligibleDueConditions(
          configSegment.content.conditions,
          inputData
        )
      ) {
        return mergeConfigSections(acc, configSegment.content.form);
      }

      return acc;
    },
    []
  );

  const flattenedMergedConfig = flatten(
    mergedConfig.reduce((acc: any, configSection: any) => {
      if (configSection[replacementSymbol]) {
        return [...acc, configSection[replacementSymbol]];
      }
      return [...acc, configSection];
    }, [])
  );

  return flattenedMergedConfig;
}

function isConfigSectionEligibleDueConditions(
  conditions: Record<string, string>,
  inputData: Record<string, string | null>
) {
  if (!conditions) {
    return true;
  }

  return toPairs(conditions).every(([key, value]) => {
    if (
      isString(value) ||
      isNumber(value) ||
      isBoolean(value) ||
      isNil(value)
    ) {
      return get(inputData, key) === value;
    }

    return false;
  });
}

function mergeConfigSections(configSectionA: any, configSectionB: any) {
  if (!isArray(configSectionA)) {
    return [];
  }

  if (isArray(configSectionB)) {
    return [...configSectionA, ...configSectionB];
  }

  if (isObject(configSectionB)) {
    const aKeysMap = configSectionA.reduce((acc, el, i) => {
      if (!el.key) {
        return acc;
      }

      return {
        ...acc,
        [el.key]: i,
      };
    }, {});

    const result = clone(configSectionA);

    toPairs(configSectionB).forEach(([bKey, bValue]) => {
      const foundAIndex = aKeysMap[bKey];

      if (foundAIndex !== undefined) {
        result[foundAIndex][replacementSymbol] = bValue;
      } else {
        result.push({
          key: bKey,
          [replacementSymbol]: bValue,
        });
      }
    });

    return result;
  }
}
